/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  AccordionDetails,
  Grid,
  Fade,
  CircularProgress,
  Button,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InventoryGrid from '../../components/InventoryGrid';
import FilterDrawer from '../../components/FilterDrawer';
import assigneeSelector from '../../selectors/killshot';
import '../../styles/Killshot.scss';
import * as killshotActionsImport from '../../redux/actions/killshot';
import ValidateUser from '../../components/UserStatus';
import DatadogViewTracker from '../../shared/utils/DatadogViewTracker';
import { initGA } from '../../utils/ga';

const styles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    padding: '10px',
    flexGrow: 1,
    position: 'relative',
  },
  killshotLoader: {
    textAlign: 'center',
    height: '80vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
  },
  iconLeft: {
    marginRight: theme.spacing(1),
  },
  gridContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
}));

const initialState = {
  showGrid: {},
  eventNameFilterValue: '',
  assigneeFilterValue: [],
  assigneeRadioValue: 'none',
  inventoryTagsFilterValue: [],
  inventoryFilterValue: 'all',
};

function Killshot(props) {
  DatadogViewTracker();
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [inventoryTags, setInventoryTags] = useState([]);
  // eslint-disable-next-line react/destructuring-assignment
  const [initialHeadliners, setInitialHeadliners] = useState([]);
  // const [initialEvents, setInitialEvents] = useState();
  // eslint-disable-next-line react/destructuring-assignment
  const [headliners, setHeadliners] = useState([]);
  const classes = styles();
  const theme = useTheme();

  const useFetchData = () => {
    useEffect(() => {
      const { killshotActions } = props;
      killshotActions.getHeadLiners();
      // killshotActions.getUsers();
      killshotActions.getTags();
    }, []);
  };

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    if (!props.headlinersLoading) {
      setHeadliners(props.headliners);
      setInitialHeadliners(props.headliners);

      const set = new Set();
      props.headliners.forEach(data => data.inventory_tags.forEach(t => set.add(t)));
      setInventoryTags(Array.from(set));
    }
  }, [props.headlinersLoading]);

  const expansionPanelStateChange = index => () => {
    const { showGrid } = state;
    setState({ ...state, showGrid: { ...showGrid, [index]: true } });
  };

  const fetchEventsFunction = (events, page, sortModel) => {
    const { killshotActions } = props;
    return killshotActions.fetchEvents(events, page, sortModel).then(res => {
      return res;
    });
  };

  const handleAssigneeRadioChange = event => {
    setState({
      ...state,
      assigneeRadioValue: event.target.value,
    });
  };

  const handleAssigneeFilterChange = (e, values) => {
    setState({
      ...state,
      assigneeFilterValue: values,
    });
  };

  const handleInventoryTagsFilterChange = (e, values) => {
    setState({
      ...state,
      inventoryTagsFilterValue: values,
    });
  };

  const handleEventNameFilterChange = e => {
    setState({
      ...state,
      eventNameFilterValue: e.target.value,
    });
  };

  const handleInventoryFilterChange = (e, values) => {
    setState({
      ...state,
      inventoryFilterValue: values,
    });
  };

  const cloneObj = (obj = {}) => {
    return JSON.parse(JSON.stringify(obj));
  };

  const assigneeFilterSubmit = () => {
    const { assigneeFilterValue, inventoryTagsFilterValue, inventoryFilterValue, eventNameFilterValue } = state;
    const hasNone = assigneeFilterValue.includes('none');
    let data;

    setLoading(true);

    if (assigneeFilterValue.length < 1) {
      data = [...initialHeadliners];
    } else {
      data = cloneObj(
        initialHeadliners.filter(d => d.tags?.pricer.some(t => assigneeFilterValue.some(av => av === t)))
      );
      if (hasNone) {
        const noneValues = cloneObj(initialHeadliners.filter(d => !d.tags?.pricer.length));
        data = [...data, ...noneValues];
      }
    }

    if (assigneeFilterValue.length) {
      data.forEach(dt => {
        // eslint-disable-next-line no-param-reassign
        dt.events = dt.events.filter(d => d.tags?.pricer.some(t => assigneeFilterValue.some(av => av === t)));
      });
    }

    if (inventoryTagsFilterValue.length) {
      data = data.filter(d => d.inventory_tags.some(it => inventoryTagsFilterValue.some(itv => itv === it)));
      data.forEach(dt => {
        // eslint-disable-next-line no-param-reassign
        dt.events = dt.events.filter(d =>
          d.inventory_tags.some(it => inventoryTagsFilterValue.some(itv => itv === it))
        );
      });
    }

    if (inventoryFilterValue?.length && inventoryFilterValue === 'new') {
      data = data.filter(d => d.ungrouped_listings);

      data.forEach(dt => {
        // eslint-disable-next-line no-param-reassign
        dt.events = dt.events.filter(d => d.ungrouped_listings);
      });
    }

    data = data.filter(d => d.name.toLowerCase().includes(eventNameFilterValue.toLowerCase()));

    setHeadliners(data);
    setTimeout(() => {
      setLoading(false);
    }, 300);
  };

  const assignUserToEvent = (eventID, pricerTag) => {
    const { killshotActions } = props;
    killshotActions.assignUserToEvent(eventID, pricerTag);
  };

  useFetchData();

  const { showGrid, assigneeFilterValue, assigneeRadioValue, eventNameFilterValue } = state;
  const { headlinersLoading, assignees, tags, user } = props;

  return (
    <main className={classes.root}>
      <FilterDrawer
        handleAssigneeRadioChange={handleAssigneeRadioChange}
        eventNameFilterValue={eventNameFilterValue}
        assignees={assignees}
        assigneeRadioValue={assigneeRadioValue}
        handleAssigneeFilterChange={handleAssigneeFilterChange}
        assigneeFilterSubmit={assigneeFilterSubmit}
        assigneeFilterValue={assigneeFilterValue}
        handleEventNameFilterChange={handleEventNameFilterChange}
        handleInventoryFilterChange={handleInventoryFilterChange}
        handleInventoryTagsFilterChange={handleInventoryTagsFilterChange}
        userEmail={user.email}
        tags={tags}
        inventoryTags={inventoryTags.filter(it => it)}
      />
      <Fade
        in={headlinersLoading || loading}
        style={{
          transitionDelay: headlinersLoading || loading ? '800ms' : '0ms',
        }}
        unmountOnExit
      >
        <div className={classes.killshotLoader}>
          <ValidateUser />
          <CircularProgress />
        </div>
      </Fade>
      {!headlinersLoading &&
        !loading &&
        // TODO: destructure
        headliners.map((headliner, index) => (
          <ExpansionPanel
            key={`${headliner.name}_${headliner.cost_of_tickets_available}`}
            onChange={expansionPanelStateChange(index)}
          >
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Grid container spacing={16}>
                <Grid item xs className={classes.gridContainerStyle}>
                  <Typography>
                    <strong>{headliner.name}</strong>
                  </Typography>
                </Grid>
                <Grid item xs className={classes.gridContainerStyle}>
                  <Typography>
                    <strong># of Events: </strong>
                    {headliner.events.length}
                  </Typography>
                </Grid>
                <Grid item xs className={classes.gridContainerStyle}>
                  <Typography>
                    <strong>COTA: </strong>
                    {`$${headliner.cost_of_tickets_available.toLocaleString()}`}
                  </Typography>
                </Grid>
                <Grid item xs className={classes.gridContainerStyle}>
                  {headliner.tags.pricer.length && (
                    <Typography>
                      <strong>Pricer: </strong>
                      {headliner.tags.pricer.join(', ')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs className={classes.gridContainerStyle}>
                  {headliner.tags.buyer.length && (
                    <Typography>
                      <strong>Buyers: </strong>
                      {headliner.tags.buyer.join(', ')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs className={classes.gridContainerStyle}>
                  <Button color="primary" variant="contained">
                    <AttachMoneyIcon />
                    Price All
                  </Button>
                </Grid>
              </Grid>
            </ExpansionPanelSummary>
            <AccordionDetails>
              <React.Fragment>
                {showGrid[index] && (
                  <>
                    <ValidateUser />
                    <InventoryGrid
                      events={headliner.events}
                      fetchEventsFunction={fetchEventsFunction}
                      tags={tags}
                      assignUserToEventFunction={assignUserToEvent}
                      theme={theme}
                    />
                  </>
                )}
                {!showGrid[index] && <Typography>Fetching events...</Typography>}
              </React.Fragment>
            </AccordionDetails>
          </ExpansionPanel>
        ))}
    </main>
  );
}

Killshot.propTypes = {
  killshotActions: PropTypes.object.isRequired,
  headliners: PropTypes.array.isRequired,
  headlinersLoading: PropTypes.bool.isRequired,
  assignees: PropTypes.array.isRequired,
  tags: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    headliners: state.killshot.headliners,
    headlinersLoading: state.killshot.headlinersLoading,
    pricersLoading: state.killshot.pricersLoading,
    pricers: state.killshot.pricers,
    tags: state.killshot.tags,
    user: state.user,
    assignees: assigneeSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    killshotActions: bindActionCreators(killshotActionsImport, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Killshot);
